// --- Bundle Builder Core Logic ---
document.addEventListener('DOMContentLoaded', function() {
  const bundleContainer = document.querySelector('.bundle-container');
  if (!bundleContainer) return;

  // Get bundle configuration from data attributes
  const bundleDiscountPercentage = parseFloat(bundleContainer.dataset.bundleDiscount) || 15;

  // Inject error message container if not present
  let bundleErrorEl = document.getElementById('bundle-error-message');
  if (!bundleErrorEl) {
    bundleErrorEl = document.createElement('div');
    bundleErrorEl.id = 'bundle-error-message';
    bundleErrorEl.className = 'bundle-error-message';
    bundleErrorEl.style.display = 'none';
    bundleErrorEl.setAttribute('role', 'alert');
    bundleErrorEl.setAttribute('aria-live', 'polite');
    bundleContainer.insertBefore(bundleErrorEl, bundleContainer.firstChild);
  }

  let bundle = [];
  const bundleSlotCount = document.querySelectorAll('.bundle-item').length;
  const bundleItemsContainer = document.querySelector('.bundle-items');
  const bundleDiscountedTotalEl = document.getElementById('bundle-discounted-total');
  const bundleSavingsEl = document.getElementById('bundle-savings');
  const addBundleToCartBtn = document.getElementById('add-bundle-to-cart');

  // Session persistence
  const SESSION_KEY = 'bundleBuilderSelections';

  function escapeForAttr(value) {
    try {
      return window.CSS && CSS.escape ? CSS.escape(value) : value.replace(/"/g, '\\"');
    } catch (e) {
      return value;
    }
  }

  function saveBundleToSession() {
    try {
      const data = {
        bundle: bundle.slice(0, bundleSlotCount),
        bundleSlotCount,
        version: 1
      };
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
    } catch (e) {
      // no-op
    }
  }

  function loadBundleFromSession() {
    try {
      const raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || !Array.isArray(data.bundle)) return null;
      return data.bundle.slice(0, bundleSlotCount);
    } catch (e) {
      return null;
    }
  }

  function clearBundleSession() {
    try {
      sessionStorage.removeItem(SESSION_KEY);
      // Also clear any cookie by the same name if it exists
      document.cookie = `${SESSION_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    } catch (e) {
      // no-op
    }
  }

  function updateCartUiFromCartData(cartData) {
    const cartItemCount = cartData.item_count;
    const cartCountSpan = document.querySelector('.cart-count-bubble');
    const cartNotificationButton = document.querySelector('#cart-notification-button');
    const cartNotification = document.querySelector('cart-notification');

    if (cartCountSpan) {
      cartCountSpan.innerHTML = `<span aria-hidden="true">&nbsp;(${cartItemCount})</span><span class="visually-hidden">&nbsp;${cartItemCount} items</span>`;
    }

    if (cartNotification) {
      if (typeof cartNotification.setCartNotificationViewButtonText === 'function') {
        cartNotification.setCartNotificationViewButtonText(cartNotificationButton, cartItemCount);
      } else if (cartNotificationButton) {
        cartNotificationButton.innerHTML = `View cart (${cartItemCount})`;
      }

      if (typeof cartNotification.updateCartTotalItemsLink === 'function') {
        cartNotification.updateCartTotalItemsLink(cartItemCount);
      }

      if (typeof cartNotification.updateCartSubtotal === 'function') {
        cartNotification.updateCartSubtotal(cartData);
      }

      if (typeof cartNotification.updateFreeShippingBar === 'function') {
        cartNotification.updateFreeShippingBar(cartData, cartNotification.minOrderAmount);
      }
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.updateFreeShippingBar === 'function') {
      cartDrawer.updateFreeShippingBar(cartData, cartDrawer.minOrderAmount);
    }
  }

  function restoreCardSelectionsFromBundle() {
    if (!Array.isArray(bundle) || bundle.length === 0) return;
    bundle.forEach(item => {
      // Prefer stored productId for card lookup; fallback to id
      const lookupId = item.productId || item.id;
      const triggerBtn = document.querySelector(`.card-wrapper .add-to-bundle-btn[data-product-id="${lookupId}"]`);
      const card = triggerBtn ? triggerBtn.closest('.card-wrapper') : null;
      if (!card) return;

      if (Array.isArray(item.selectedOptionsData)) {
        item.selectedOptionsData.forEach(option => {
          const optNameEscaped = escapeForAttr(option.name);
          // Try name-suffix match first to target the correct option group
          const radiosExact = card.querySelectorAll(`input[type="radio"][name$="-${optNameEscaped}"]`);
          let matched = false;
          radiosExact.forEach(r => {
            if (r.value === option.value) {
              r.checked = true;
              r.dispatchEvent(new Event('change', { bubbles: true }));
              matched = true;
            }
          });
          if (!matched) {
            // Fallback: any radio within the card with matching value
            const anyRadio = Array.from(card.querySelectorAll('input[type="radio"]')).find(rr => rr.value === option.value);
            if (anyRadio) {
              anyRadio.checked = true;
              anyRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      }
      // Refresh button state
      updateAddToBundleButtonState(card);
    });
  }

  function updateBundleUI() {
    // For i18n
    const selectProductText = window.themeStrings?.selectProduct || 'Select Product';
    const youSavedText = window.themeStrings?.youSaved || 'You saved';
    // Update bundle slots
    bundleItemsContainer.innerHTML = '';
    // Use DocumentFragment for efficient DOM updates
    const fragment = document.createDocumentFragment();
    // Read placeholder image from DOM attribute once
    const placeholderImageFromDom = bundleItemsContainer.getAttribute('data-placeholder-image') || '';
    // Expose to window for internal usage
    window.bundlePlaceholderImage = placeholderImageFromDom;

    for (let i = 0; i < bundleSlotCount; i++) {
      const item = bundle[i];
      const bundleItemEl = document.createElement('div');
      bundleItemEl.classList.add('bundle-item');
      bundleItemEl.id = `bundle-item-${i}`;
      // Accessibility: Add role and aria-label to each bundle slot
      bundleItemEl.setAttribute('role', 'group');
      bundleItemEl.setAttribute('aria-label', `Bundle slot ${i + 1} of ${bundleSlotCount}`);
      if (item) {
        const perItemDiscountMultiplier = (100 - bundleDiscountPercentage) / 100;
        const originalPrice = Math.round(parseFloat(item.price) * 100) / 100;
        const discountedPrice = Math.round(originalPrice * perItemDiscountMultiplier * 100) / 100;
        bundleItemEl.innerHTML = `
          <div class="bundle-item-content">
            <img src="${item.image}" alt="${item.title}">
            <button class="button button--tertiary remove-from-bundle" data-index="${i}" title="Remove from bundle" aria-label="Remove ${item.title} from bundle">
              <svg class="icon icon-close" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 6.91L17.59 5.5L12 11.09L6.41 5.5L5 6.91L10.59 12.5L5 18.09L6.41 19.5L12 13.91L17.59 19.5L19 18.09L13.41 12.5L19 6.91Z" fill="currentColor"></path>
              </svg>
            </button>
            <div class="bundle-item-details">
              <div class="bundle-product-title card__heading h5">${item.title}</div>
              ${item.selectedOptionsData && item.selectedOptionsData.length > 0 ?
                item.selectedOptionsData.map(option => `<div class="bundle-item-variant" data-option-name="${option.name}"><span class="swatch-name-label">${option.name}</span>: ${option.value}</div>`).join('')
                : (item.variantTitle && item.variantTitle !== 'Default Title' ? `<div class="bundle-item-variant">${item.variantTitle}</div>` : '')
              }
              <div class="bundle-item-prices">
                <span class="bundle-item-price-original">$${originalPrice.toFixed(2)}</span>
                <span class="bundle-item-price-discounted">$${discountedPrice.toFixed(2)}</span>
              </div>
            </div>
          </div>
        `;
      } else {
        // Accessibility: Make placeholder focusable and add aria-label, include numbered label
        const numberedText = `${selectProductText} ${i + 1}`;
        bundleItemEl.innerHTML = `
          <div class="bundle-item-content bundle-placeholder">
            <img src="${(window.bundlePlaceholderImage || '')}" alt="Bundle Placeholder ${i + 1}">
            <div class="bundle-item-details">
              <div class="bundle-product-title card__heading h5" tabindex="0" aria-label="Empty bundle slot ${i + 1} of ${bundleSlotCount}. ${numberedText}.">${numberedText}</div>
            </div>
          </div>
        `;
      }
      fragment.appendChild(bundleItemEl);
    }
    bundleItemsContainer.appendChild(fragment);

    // Update totals using dynamic discount percentage
    const originalTotal = bundle.reduce((sum, item) => sum + parseFloat(item.price), 0);
    const discountMultiplier = (100 - bundleDiscountPercentage) / 100;
    const discountedTotal = Math.round(originalTotal * discountMultiplier * 100) / 100;
    const savings = originalTotal - discountedTotal;

    if (bundleDiscountedTotalEl) bundleDiscountedTotalEl.textContent = `$${discountedTotal.toFixed(2)}`;
    if (bundle.length > 0) {
      if (bundleSavingsEl) bundleSavingsEl.textContent = `\u00A0(${youSavedText} $${savings.toFixed(2)})`;
      if (bundleSavingsEl) bundleSavingsEl.style.display = 'inline';
      // Only show discounted total inside the button when bundle is complete
      if (bundleDiscountedTotalEl) bundleDiscountedTotalEl.style.display = (bundle.length === bundleSlotCount) ? 'inline' : 'none';
    } else {
      if (bundleSavingsEl) bundleSavingsEl.textContent = `\u00A0(${youSavedText} $0.00)`;
      if (bundleSavingsEl) bundleSavingsEl.style.display = 'none';
      if (bundleDiscountedTotalEl) bundleDiscountedTotalEl.style.display = 'none';
    }

    // Update 'Add to Cart' button label (keep savings span intact)
    const remaining = bundleSlotCount - bundle.length;
    const labelSpan = addBundleToCartBtn.querySelector('#add-bundle-label');
    if (labelSpan) {
      if (remaining === 0) {
        // Include trailing dash before price span with non-breaking spaces
        labelSpan.textContent = `${window.themeStrings?.addBundleToCart || 'Add Bundle to Cart'}\u00A0-\u00A0`;
      } else {
        labelSpan.textContent = `Select ${remaining} More Product${remaining > 1 ? 's' : ''}`;
      }
    }
    addBundleToCartBtn.disabled = bundle.length !== bundleSlotCount;

    // Persist current bundle to session storage
    saveBundleToSession();
  }

  function updateAddToBundleButtonState(card) {
    const btn = card.querySelector('.add-to-bundle-btn');
    if (!btn) return;

    const radios = card.querySelectorAll('input[type="radio"]');
    if (radios.length === 0) {
      btn.disabled = false;
      return;
    }

    const optionNames = [...new Set(Array.from(radios).map(r => r.name))];
    const allOptionsSelected = optionNames.every(name => card.querySelector(`input[type="radio"][name="${name}"]:checked`));
    if (!allOptionsSelected) {
      btn.classList.remove('disabled');
      btn.disabled = true;
      btn.textContent = window.themeStrings?.addToBundle || 'Add to Bundle';
      return;
    }

    // If all options selected, also consider availability
    const productVariants = card.dataset.productVariants ? JSON.parse(card.dataset.productVariants) : [];
    const selectedOptionValues = optionNames.map(name => card.querySelector(`input[type="radio"][name="${name}"]:checked`).value);
    const selectedVariant = productVariants.find(v => JSON.stringify(v.options) === JSON.stringify(selectedOptionValues));
    if (selectedVariant && selectedVariant.available === false) {
      btn.classList.add('disabled');
      btn.disabled = true;
      btn.textContent = window.themeStrings?.soldOut || 'Sold Out';
    } else {
      btn.classList.remove('disabled');
      btn.disabled = false;
      btn.textContent = window.themeStrings?.addToBundle || 'Add to Bundle';
    }
  }

  document.querySelectorAll('.product-card-wrapper').forEach(card => {
    updateAddToBundleButtonState(card);
    card.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"]')) {
        updateAddToBundleButtonState(card);
      }
    });
  });

  document.addEventListener('click', function(e) {
    // Close product options modal
    if (e.target.matches('.product-options-modal [data-modal-close="true"]')) {
      const modal = e.target.closest('.product-options-modal');
      if (modal) {
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
      }
      return;
    }
    // Choose options
    if (e.target.matches('.choose-options-btn')) {
      const btn = e.target;
      const productId = btn.dataset.productId;
      const modal = document.getElementById(`product-options-${productId}`);
      if (modal) {
        modal.setAttribute('aria-hidden', 'false');
        const firstFocusable = modal.querySelector('input[type="radio"], .product-options-close');
        if (firstFocusable) firstFocusable.focus();
        document.documentElement.classList.add('no-scroll');
      }
    }

    // Remove from bundle
    if (e.target.matches('.remove-from-bundle')) {
      const index = parseInt(e.target.dataset.index);
      bundle.splice(index, 1);
      updateBundleUI();
      // Accessibility: Move focus to next slot or add button
      setTimeout(() => {
        const nextSlot = document.getElementById(`bundle-item-${index}`) || document.getElementById('add-bundle-to-cart');
        if (nextSlot) {
          if (nextSlot.querySelector('.remove-from-bundle')) {
            nextSlot.querySelector('.remove-from-bundle').focus();
          } else if (nextSlot.querySelector('.bundle-placeholder')) {
            nextSlot.querySelector('.bundle-placeholder').focus();
          } else {
            nextSlot.focus();
          }
        }
      }, 0);
      return;
    }

    // Add to bundle
    if (e.target.matches('.add-to-bundle-btn')) {
      e.preventDefault();
      if (e.target.disabled) return;
      if (bundle.length >= bundleSlotCount) return;

      const card = e.target.closest('.card-wrapper') || e.target.closest('.product-options-modal');
      // Require explicit selection for each option group if radios exist
      const allRadios = card.querySelectorAll('input[type="radio"]');
      if (allRadios.length > 0) {
        const optionNames = [...new Set(Array.from(allRadios).map(r => r.name))];
        const firstUnselectedName = optionNames.find(name => !card.querySelector(`input[type="radio"][name="${name}"]:checked`));
        if (firstUnselectedName) {
          const productId = e.target.dataset.productId;
          const optionsContainer = document.querySelector(`.product-options-container[data-product-id="${productId}"]`);
          if (optionsContainer && !optionsContainer.classList.contains('show')) {
            optionsContainer.classList.add('show');
            const chooseBtn = card.querySelector('.choose-options-btn');
            if (chooseBtn) chooseBtn.textContent = 'Hide Options';
          }
          const unselectedInput = card.querySelector(`input[type="radio"][name="${firstUnselectedName}"]`);
          if (unselectedInput) {
            unselectedInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const unselectedLabel = unselectedInput.closest('.swatch-input-button')?.querySelector('label');
            if (unselectedLabel) unselectedLabel.focus();
          }
          return;
        }
      }
      const productTitle = card.querySelector('.card__heading a')?.textContent.trim() || card.getAttribute('data-product-title') || '';
      const productImage = card.querySelector('img')?.src || '';
      const selectedRadios = card.querySelectorAll('input[type="radio"]:checked');
      let variantTitle = '';
      let price = 0;
      let id = card.querySelector('.add-to-bundle-btn').dataset.productId;
      const productIdData = card.querySelector('.add-to-bundle-btn').dataset.productId;
      let selectedOptionsData = []; // Initialize here

      if (selectedRadios.length > 0) {
        const productVariants = card.dataset.productVariants ? JSON.parse(card.dataset.productVariants) : (card.getAttribute('data-product-variants') ? JSON.parse(card.getAttribute('data-product-variants')) : []);
        const selectedOptionValues = Array.from(selectedRadios).map(radio => radio.value);

        // Populate selectedOptionsData from selected radios
        selectedRadios.forEach(radio => {
          const optionName = radio.name.split('-')[2]; // Extract option name from radio button name
          const optionValue = radio.value;
          selectedOptionsData.push({ name: optionName, value: optionValue });
        });

        const selectedVariant = productVariants.find(v => JSON.stringify(v.options) === JSON.stringify(selectedOptionValues));

        if (selectedVariant) {
          // Guard against adding sold out variant
          if (selectedVariant.available === false) {
            const btn = card.querySelector('.add-to-bundle-btn');
            if (btn) {
              btn.classList.add('disabled');
              btn.disabled = true;
              btn.textContent = window.themeStrings?.soldOut || 'Sold Out';
            }
            return;
          }
          variantTitle = selectedVariant.title;
          price = selectedVariant.price / 100;
          id = selectedVariant.id;
        }
      } else {
        // Handle single-variant products or products without explicit options (e.g., "Default Title")
        const productVariants = card.dataset.productVariants ? JSON.parse(card.dataset.productVariants) : (card.getAttribute('data-product-variants') ? JSON.parse(card.getAttribute('data-product-variants')) : []);
        if (productVariants.length === 1) {
          const variant = productVariants[0];
          variantTitle = variant.title;
          price = variant.price / 100;
          id = variant.id;

          // For single variant, get option name and value from visually-hidden swatch-name divs
          card.querySelectorAll('.swatch-name[data-option-name]').forEach(swatchNameDiv => {
            const optionName = swatchNameDiv.dataset.optionName;
            const optionValue = swatchNameDiv.querySelector('.swatch-name-value').textContent.trim();
            selectedOptionsData.push({ name: optionName, value: optionValue });
          });
        }
      }

      bundle.push({
        id,
        productId: productIdData,
        title: productTitle,
        image: productImage,
        variantTitle,
        price,
        selectedOptionsData // Add this new property
      });

      updateBundleUI();
      // If added from modal, close it
      const modalEl = e.target.closest('.product-options-modal');
      if (modalEl) {
        modalEl.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
      }
      // Accessibility: Move focus to next empty slot
      setTimeout(() => {
        const nextEmpty = document.querySelector('.bundle-placeholder');
        if (nextEmpty) nextEmpty.focus();
      }, 0);
    }

    // Add bundle to cart
    if (e.target.matches('#add-bundle-to-cart')) {
      if (bundle.length !== bundleSlotCount) return;

      // Clear any previous error message
      bundleErrorEl.textContent = '';
      bundleErrorEl.style.display = 'none';

      // Loader logic start
      const addBtn = e.target;
      addBtn.setAttribute('aria-disabled', 'true');
      addBtn.classList.add('loading');
      let spinner = addBtn.querySelector('.loading__spinner');
      if (!spinner) {
        spinner = document.createElement('span');
        spinner.className = 'loading__spinner';
        spinner.innerHTML = `<svg class="spinner" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>`;
        addBtn.appendChild(spinner);
      }
      spinner.classList.remove('hidden');
      // Loader logic end

      const items = bundle.map(item => ({
        id: parseInt(item.id),
        quantity: 1,
        properties: {
          _Bundle: 'true',
          _Bundle_Title: item.title,
          _Bundle_Variant: item.variantTitle,
        },
      }));

      // Make a copy of the bundle before clearing it
      const justAddedBundle = [...bundle];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(errorData => {
            // Show error message to user
            bundleErrorEl.textContent = errorData.description || 'Error adding bundle to cart.';
            bundleErrorEl.style.display = 'block';
            throw new Error(errorData.description || 'Error adding bundle to cart');
          });
        }
        return response.json();
      })
      .then(() => {
        // Clear error message on success
        bundleErrorEl.textContent = '';
        bundleErrorEl.style.display = 'none';
        // Show only the just-added bundle items in the notification and update cart count
        if (justAddedBundle.length > 0 && window.customElements && customElements.get('cart-notification')) {
          // Fetch the updated cart to get full item data (with discounts, etc.)
          fetch('/cart.json')
            .then(res => res.json())
            .then(cartData => {
              // Find items in cart that match the just added bundle (by variant_id and _Bundle property)
              const itemsForNotification = cartData.items.filter(cartItem => {
                return justAddedBundle.some(bundleItem => {
                  // Match by variant_id and _Bundle property
                  return (
                    String(cartItem.variant_id) === String(bundleItem.id) &&
                    cartItem.properties && cartItem.properties._Bundle === 'true'
                  );
                });
              });
              document.querySelector('cart-notification').showCustomItems(itemsForNotification, 'Bundle added to cart!');
              updateCartUiFromCartData(cartData);
            });
        } else {
          // If no notification, still update cart count by fetching cart data
          fetch('/cart.json')
            .then(res => res.json())
            .then(cartData => updateCartUiFromCartData(cartData));
        }
        // Clear session persistence after successful add to cart
        clearBundleSession();
        bundle = [];
        updateBundleUI();
      })
      .catch(error => {
        // Show error message to user if not already shown
        if (!bundleErrorEl.textContent) {
          bundleErrorEl.textContent = error.message || 'An error occurred. Please try again.';
          bundleErrorEl.style.display = 'block';
        }
        console.error('Bundle add error:', error);
      })
      .finally(() => {
        // Loader logic cleanup
        addBtn.classList.remove('loading');
        addBtn.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
    }
  });

  // Initial setup
  const restored = loadBundleFromSession();
  if (restored) {
    bundle = restored;
  }
  updateBundleUI();
  // Try to restore option selections in the product cards too
  restoreCardSelectionsFromBundle();
  // Accessibility: Ensure focus outlines are visible (CSS responsibility)
});

document.addEventListener('change', function(event) {
  if (event.target.matches('.swatch-container input[type="radio"]')) {
    const radio = event.target;
    const swatchContainer = radio.closest('.swatch-container');
    if (swatchContainer) {
      const swatchName = swatchContainer.previousElementSibling;
      if (swatchName && swatchName.classList.contains('swatch-name')) {
        const swatchNameValue = swatchName.querySelector('.swatch-name-value');
        if (swatchNameValue) {
          swatchNameValue.textContent = radio.value;
        }
      }

      const card = radio.closest('.card-wrapper') || radio.closest('.product-options-modal');
      if (card) {
        const btn = card.querySelector('.add-to-bundle-btn');
        if (btn) {
          // Find all selected radios for this card
          const selectedRadios = card.querySelectorAll('input[type="radio"]:checked');
          const productVariants = card.dataset.productVariants ? JSON.parse(card.dataset.productVariants) : (card.getAttribute('data-product-variants') ? JSON.parse(card.getAttribute('data-product-variants')) : []);
          let selectedVariant = null;
          if (selectedRadios.length > 0 && productVariants.length > 0) {
            // Get selected option values in order
            const selectedOptionValues = Array.from(selectedRadios).map(radio => radio.value);
            selectedVariant = productVariants.find(v => JSON.stringify(v.options) === JSON.stringify(selectedOptionValues));
          } else if (productVariants.length === 1) {
            selectedVariant = productVariants[0];
          }
          if (selectedVariant && selectedVariant.available === false) {
            btn.classList.add('disabled');
            btn.disabled = true;
            btn.textContent = window.themeStrings.soldOut || 'Sold Out';
          } else {
            btn.classList.remove('disabled');
            // Only enable if all options are selected
            const optionNames = [...new Set(Array.from(card.querySelectorAll('input[type="radio"]')).map(r => r.name))];
            const allOptionsSelected = optionNames.every(name => card.querySelector(`input[type="radio"][name="${name}"]:checked`));
            btn.disabled = !allOptionsSelected;
            btn.textContent = window.themeStrings.addToBundle || 'Add to Bundle';
          }
        }
      }
    }
  }
});
